import { type OfferV11 } from '@redteclab/api/clients/bully'

import { type OFFER_PROMOTION_TYPE } from '../../../offer'

import { productAccessorIsSaeOffer } from './productAccessorIsSaeOffer'

export const productAccessorGetOfferPromotionType = (
  offer: OfferV11,
): OFFER_PROMOTION_TYPE | undefined => {
  if (!productAccessorIsSaeOffer(offer)) {
    return undefined
  }

  const promotionType = offer.offerPromotion?.promotionType as
    | OFFER_PROMOTION_TYPE
    | undefined

  return promotionType ?? undefined
}
